import React from "react";
import { Wheel } from "react-custom-roulette";
import { WheelContainer, OuterBadge } from "../SpinHome.style";

// const textColors = ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#8D918D', '#ffffff'];
// const backgroundColors = ['#FFA500', '#6698FF', '#F75D59', '#A74AC7', '#F8F8FF', '#FF00FF'];

const textColors = ["#FFFFFF", '#000000'];
const backgroundColors = ["#006400", "#ffffff"];


const props = {
	textColors,
	backgroundColors,
	fontFamily: "Archivo",
	fontWeight: "bold",
	fontSize: 16,
	radiusLineWidth: 0,
	outerBorderWidth: 0,
	innerBorderColor: "#006400",
	innerBorderWidth: 1,
	innerRadius: 0,
	textDistance: 70,
};

const SpinWheel = ({
	handleSpinClicked,
	started,
	winningIndex,
	spinValues,
	handleStop,
}) => {
	return (
		<div
			style={{
				position: "relative",
				zIndex: 1000
			}}
		>
			<WheelContainer>
				<Wheel
					disableInitialAnimation={true}
					mustStartSpinning={started}
					prizeNumber={winningIndex}
					data={spinValues}
					onStopSpinning={handleStop}
					{...props}
				/>
				<OuterBadge onClick={handleSpinClicked} />
			</WheelContainer>
		</div>
	);
};

export default SpinWheel;
